// extracted by mini-css-extract-plugin
export var alternate = "_17-j";
export var black = "_17-6";
export var blue = "_17-f";
export var blueLight = "_17-e";
export var brand = "_17-8";
export var darkMode = "_17-b";
export var error = "_17-a";
export var gray = "_17-5";
export var grayBlue = "_17-d";
export var iconWrapper = "_17-3";
export var inactive = "_17-7";
export var indigo = "_17-g";
export var orange = "_17-i";
export var pink = "_17-h";
export var primary = "_17-0";
export var purple = "_17-9";
export var success = "_17-4";
export var warning = "_17-c";
export var white = "_17-1";
export var whiteSuccess = "_17-2";